__turbopack_context__.v({
  "className": "reckless_11a8766f-module__t4dHma__className",
  "variable": "reckless_11a8766f-module__t4dHma__variable",
});
